import { PersonDto } from 'dtos'
import { FedExShipmentDto } from 'dtos/fedEx'
import { OhioOutgoingTitleVehicleDto } from './OhioOutgoingTitleVehicleDto'

export class OhioOutgoingTitleDto {
  ohioOutgoingTitleGuid?: string = undefined
  isLocked?: boolean = false
  vehicles?: OhioOutgoingTitleVehicleDto[] = undefined
  fedExShipment?: FedExShipmentDto = undefined
  createdByPerson?: PersonDto = undefined
  createdDateTime?: string = undefined
  updatedByPerson?: PersonDto = undefined
  updatedDateTime?: string = undefined
}
